import { ArrowLeft, ExternalLink, Radio } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const VIDEO_ID = "X83mPwE6rg8";
const YOUTUBE_URL = `https://youtu.be/${VIDEO_ID}`;

const PacificNorthwestLive = () => (
  <section className="bg-background py-8 sm:py-12">
    <div className="container mx-auto max-w-5xl px-4">
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="mb-1 flex items-center gap-2 text-sm font-semibold text-destructive">
            <Radio className="h-4 w-4 animate-pulse" /> Live stream
          </div>
          <h1 className="text-2xl font-bold text-foreground sm:text-3xl">
            Pacific Northwest Region Conference
          </h1>
        </div>
        <Button asChild variant="outline">
          <Link to="/">
            <ArrowLeft className="mr-2 h-4 w-4" /> Back to home
          </Link>
        </Button>
      </div>

      <div className="aspect-video w-full overflow-hidden rounded-lg border bg-muted shadow-sm">
        <iframe
          className="h-full w-full"
          src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
          title="Pacific Northwest Region 2026 Conference live stream"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </div>

      <div className="mt-4 flex justify-center">
        <Button asChild variant="outline">
          <a href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer">
            <ExternalLink className="mr-2 h-4 w-4" /> Open in YouTube
          </a>
        </Button>
      </div>
    </div>
  </section>
);

export default PacificNorthwestLive;